<template>
  <div class="admin-tabs-bar">
    <div class="admin-tabs">

       <!-- Company Info -->
       <router-link
          v-if="permission?.settings_module == 1 && loggedInUser.is_super == 1"
          :to="$url('/company-info')"
          class="admin-tab"
          :class="{ 'admin-tab--active': isActive(['Edit Company Info','Company Info']) }"
        >
          <font-awesome-icon icon="building" class="tab-icon" />
          Company Info
        </router-link>

      <router-link
        v-if="permission?.view_employee == 1"
        :to="$url('/manage-user')"
        class="admin-tab"
        :class="isActive(['Manage User', 'Create User', 'Edit User']) ? 'admin-tab--active' : ''"
      >
        <font-awesome-icon icon="users" class="tab-icon" />
        Users
      </router-link>

      <router-link
        v-if="permission?.view_roles == 1"
        :to="$url('/manage-role')"
        class="admin-tab"
        :class="isActive(['Manage Role', 'Create Role', 'Edit Role']) ? 'admin-tab--active' : ''"
      >
        <font-awesome-icon icon="user-shield" class="tab-icon" />
        Roles
      </router-link>

      <router-link
        v-if="permission?.view_company == 1"
        :to="$url('/businesses')"
        class="admin-tab"
        :class="isActive(['All Business', 'Create Business', 'Edit Business']) ? 'admin-tab--active' : ''"
      >
        <font-awesome-icon icon="building" class="tab-icon" />
        Businesses
      </router-link>

      <router-link
        v-if="permission?.view_location == 1"
        :to="$url('/manage-business-locations')"
        class="admin-tab"
        :class="isActive(['Manage Business Locations']) ? 'admin-tab--active' : ''"
      >
        <font-awesome-icon icon="building" class="tab-icon" />
        Business Locations
      </router-link>

      <router-link
          v-if="permission?.view_workflow == 1"
          :to="$url('/workflow-setup')"
          class="admin-tab"
          :class="{ 'admin-tab--active': isActive(['Manage Workflow Setup']) }"
        >
          <font-awesome-icon icon="users" class="tab-icon" />
          Workflow Setup
        </router-link>

        <!-- Business Banks -->
        <router-link
          v-if="permission?.view_bank == 1"
          :to="$url('/business-bank-accounts')"
          class="admin-tab"
          :class="{ 'admin-tab--active': isActive(['Manage Business Bank Accounts']) }"
        >
          <font-awesome-icon icon="university" class="tab-icon" />
          Bank Accounts
        </router-link>

        <!-- All Banks -->
        <router-link
          v-if="permission?.view_bank == 1"
          :to="$url('/all-banks')"
          class="admin-tab"
          :class="{ 'admin-tab--active': isActive(['Manage All Banks']) }"
        >
          <font-awesome-icon icon="university" class="tab-icon" />
          Banks
        </router-link>

        <!-- All Banks -->
        <router-link
          v-if="permission?.view_bank == 1"
          :to="$url('/pension-providers')"
          class="admin-tab"
          :class="{ 'admin-tab--active': isActive(['Manage Pension Providers']) }"
        >
          <font-awesome-icon icon="university" class="tab-icon" />
          Pension Providers
        </router-link>

        <!-- Financial Period -->
        <router-link
          v-if="permission?.view_financial_period == 1"
          :to="$url('/financial-period')"
          class="admin-tab"
          :class="{ 'admin-tab--active': isActive(['Financial Period']) }"
        >
          <font-awesome-icon icon="coins" class="tab-icon" />
          Financial Period
        </router-link>
        <!-- <template v-if="permission?.view_financial_period == 1">
          <router-link v-if="!freemium" :to="$url('/financial-period')" class="admin-tab" 
            :class="{ 'admin-tab--active': isActive(['Financial Period']) }">
            <font-awesome-icon icon="calendar-alt" class="tab-icon" />
            Financial Period
          </router-link>
          <button v-else class="admin-tab tab-item--locked" @click="freemiumPrompt">
            <font-awesome-icon icon="lock" class="tab-icon tab-icon--lock" />
            Financial Period
          </button>
        </template> -->

        <!-- Currencies -->
        <router-link
          v-if="permission?.view_currency == 1"
          :to="$url('/all-currencies')"
          class="admin-tab"
          :class="{ 'admin-tab--active': isActive(['All Currency']) }"
        >
          <font-awesome-icon icon="coins" class="tab-icon" />
          Currencies
        </router-link>

        <!-- Payment Gateway -->
        <router-link
          v-if="permission?.view_payment_gateway == 1"
          :to="$url('/payment-gateway')"
          class="admin-tab"
          :class="{ 'admin-tab--active': isActive(['Payment Gateway']) }"
        >
          <font-awesome-icon icon="credit-card" class="tab-icon" />
          Payment Gateway
        </router-link>

    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useToast } from 'vue-toastification';
import { ref, computed, onMounted } from 'vue';
import axios from 'axios';

export default {
  setup() {
    const store  = useStore();
    const toast  = useToast();
    const router = useRouter();
    const permission = computed(() => store.state.getCurrentUserPermission);
    const loggedInUser = computed(() => store.state.getLoggedInUser);

    const freemium = ref(true);
    const freemiumPrompt = () => toast.error('Subscribe or upgrade to use this feature.');

    const activeSubscription = () => {
      axios.get('/subscription/user')
        .then(({ data }) => {
          freemium.value = !data.data.some(d => d.status === 1 || d.status === 0);
        })
        .catch(() => {});
    };

    const isActive = (names) => names.includes(router.currentRoute.value.name);

    onMounted(async () => {
      activeSubscription();
    });

    return { permission, isActive, loggedInUser, freemium, freemiumPrompt, activeSubscription };
  },
};
</script>

<style scoped>
.admin-tabs-bar {
  background: #fff;
  border-bottom: 1px solid #e4eaf2;
  padding: 0 20px;
  margin-bottom: 20px;
}

.admin-tabs {
  display: flex;
  align-items: center;
  gap: 4px;
  overflow-x: auto;
  scrollbar-width: none;
}
.admin-tabs::-webkit-scrollbar { display: none; }

.admin-tab {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 13px 16px;
  font-size: 13.5px;
  font-weight: 500;
  color: #7a90b0;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s;
  margin-bottom: -1px;
}
.admin-tab:hover { color: #004AAD; text-decoration: none; }

.admin-tab--active {
  color: #004AAD;
  border-bottom-color: #004AAD;
  font-weight: 600;
}

.tab-icon {
  font-size: 13px;
  opacity: 0.85;
}

@media (max-width: 576px) {
  .admin-tabs-bar { padding: 0 12px; }
  .admin-tab { padding: 12px 12px; font-size: 13px; }
}
</style>